import { render, staticRenderFns } from "./ArticleSetForm.vue?vue&type=template&id=5e355e54&"
import script from "./ArticleSetForm.vue?vue&type=script&lang=js&"
export * from "./ArticleSetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports